// extracted by mini-css-extract-plugin
module.exports = {"banner":"index-module__banner___k0NeL","bannerInline":"index-module__bannerInline___FWF7J","text":"index-module__text___Smfmi","timer":"index-module__timer___PvsyI"};